import { render, staticRenderFns } from "./addTraceModule.vue?vue&type=template&id=00dc557a&scoped=true"
import script from "./addTraceModule.vue?vue&type=script&lang=js"
export * from "./addTraceModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc557a",
  null
  
)

export default component.exports